import { compose, withState, withHandlers } from "recompose";
import { withRouter } from "react-router";

const EnhanceConnectedAccount = (BaseComponent) =>
  compose(
    withRouter,
    withState("displayAccount", "setDisplayAccount", false),
    withHandlers({
      toggleAccount: (props) => () =>
        props.setDisplayAccount(!props.displayAccount),
      redirectToAccount: (props) => () => {
        props.setDisplayAccount(false);
        props.history.push("/user");
      },
    })
  )(BaseComponent);

export default EnhanceConnectedAccount;
